import {
  type CuratedAlbumKey,
  decodeAlbumSelection,
  encodeAlbumSelection,
} from '@/lib/photos/album-selection'
import { readStoredPhotosTrayAlbum } from '@/lib/photos/photos-tray-album-storage'

export const DEFAULT_PHOTOS_TRAY_ALBUM_KEY: CuratedAlbumKey = 'all-photos'

export function getDefaultPhotosTrayAlbumValue(): string {
  return encodeAlbumSelection({ type: 'curated', key: DEFAULT_PHOTOS_TRAY_ALBUM_KEY })
}

export function getRecommendForSpreadAlbumValue(): string {
  return encodeAlbumSelection({ type: 'curated', key: 'recommended' })
}

/**
 * Returns the last user-selected tray album, or All photos when none is saved (WMPCM-1999).
 */
export function readPersistedPhotosTrayAlbumValue(storedAlbumValue?: string | null): string {
  const stored = storedAlbumValue ?? readStoredPhotosTrayAlbum()

  if (stored && decodeAlbumSelection(stored)) {
    return stored
  }

  return getDefaultPhotosTrayAlbumValue()
}

/** True when Recommend for spread should win over a saved album. */
export function shouldPreferRecommendForSpread(
  photos: ReadonlyArray<{ recommendedFlag?: boolean }>
): boolean {
  return photos.some((photo) => photo.recommendedFlag === true)
}

/**
 * Resolves the tray album when an NS spread is open.
 * Prefer Recommend for spread when any candid has recommendedFlag; otherwise use saved/default.
 * Does not mutate localStorage — callers should only update React state for the override.
 */
export function resolvePhotosTrayAlbumForOpenSpread(
  spreadRecommendPhotos: ReadonlyArray<{ recommendedFlag?: boolean }>,
  storedAlbumValue?: string | null
): string {
  if (shouldPreferRecommendForSpread(spreadRecommendPhotos)) {
    return getRecommendForSpreadAlbumValue()
  }

  return readPersistedPhotosTrayAlbumValue(storedAlbumValue)
}
